import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { ApiService } from '../core/upgraded-providers';

@Injectable()
export class WorldMapStatusResolver implements Resolve<any> {
    constructor(
        private _apiService: ApiService
    ) {
    }

    resolve(): Promise<any> {
        return new Promise(async (resolve) => {
            try {
                const data = await this._apiService.get('user/world-status');
                const status = data.status;

                resolve(status);
            } catch (err) {
                // TODO: Need to add handler for world status error.
                // reject();
            }
        });
    }
}
